/** The money summary card on the "New booking" form. See
 *  `CreateBookingModalHelpers.ts#computeMoneySummary` for why only the subtotal
 *  is priced here. */
import { formatMoney, type MoneySummary } from './CreateBookingModalHelpers';

export function CreateBookingMoneySection({ money }: { money: MoneySummary }) {
  if (money.kind === 'none') return null;
  return (
    <div className="rounded-xl bg-stone-50 p-4 text-sm dark:bg-[#1e2520]">
      {money.kind === 'free' ? (
        <div className="flex items-center justify-between font-bold text-bark-900 dark:text-stone-100">
          <span>Total</span>
          <span>Free — comp</span>
        </div>
      ) : (
        <div className="space-y-1.5">
          <div className="flex items-center justify-between text-stone-600 dark:text-stone-400">
            <span>Subtotal</span>
            <span>{formatMoney(money.subtotalCents)}</span>
          </div>
          <div className="text-xs text-stone-400">
            {money.serviceFeeEnabled === false
              ? 'Sales tax — calculated at checkout'
              : 'Service fee & sales tax — calculated at checkout'}
          </div>
          <div className="flex items-center justify-between border-t border-stone-200 pt-1.5 font-bold text-bark-900 dark:border-stone-700 dark:text-stone-100">
            <span>
              {money.serviceFeeEnabled === false ? 'Total (pre-tax)' : 'Total (before fee & tax)'}
            </span>
            <span>{formatMoney(money.subtotalCents)}</span>
          </div>
        </div>
      )}
    </div>
  );
}
